import React from 'react';
import autoBind from 'react-autobind';
import Paper from 'material-ui/Paper';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import { List } from 'material-ui/List';
//import { Tooltip } from 'material-ui/core/Tooltip';
import Divider from 'material-ui/Divider';
import { GroupRecord, PermissionRecord } from '../../../feathers/records';
import GroupModal from '../../../components/GroupModal';
import GroupListItem from './GroupListItem';
import style from './style.js';

export default class Groups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentlyEditing: null,
      currentTotal: 0
    };
    autoBind(this);
  }

  handleOpenModal(group, totalCount) {
    this.setState({ currentTotal: totalCount, currentlyEditing: group });
  }

  handleCloseModal() {
    this.setState({ currentlyEditing: null });
  }

  componentDidMount() {
    PermissionRecord.find();
  }

  render() {
    const { groups, permissions, invitations, disabled } = this.props;
    var permissionCats = [];
    permissions.toList().forEach(permission => {
      permissionCats = permissionCats.concat(permission.permissions.groups);
    });
    var invitationCats = [];
    invitations.toList().forEach(invitation => {
      invitationCats = invitationCats.concat(invitation.permissions.groups);
    });

    return (
      <div className="margin-bottom-30">
        {this.state.currentlyEditing && (
          <GroupModal
            group={this.state.currentlyEditing}
            onRequestClose={this.handleCloseModal}
            totalCount={this.state.currentTotal}
          />
        )}
        <Paper className="col-xs-7">
          <div className="container-paper">
            <div className="row">
              <div className="col-xs-7">
                <p className="text-muted">{`${groups.size} groups`}</p>
              </div>
              <div className="col-sm-6 margin-bottom-15">
                <RaisedButton
                  primary
                  label="New Group"
                  onClick={() => this.handleOpenModal(new GroupRecord(), 0)}
                  disabled={disabled}
                />
              </div>
            </div>
            {groups.size > 0 && (
              <div>
                <List style={style.groupList}>
                  {groups.toList().map(group => {
                    return (
                      <div key={group._id}>
                        <GroupListItem
                          permissionCats={permissionCats}
                          invitationCats={invitationCats}
                          group={group}
                          disabled={disabled}
                          onOpenModal={this.handleOpenModal}
                        />
                        <Divider />
                      </div>
                    );
                  })}
                </List>
              </div>
            )}
          </div>
        </Paper>
        {this.state.fetching && <LinearProgress mode="indeterminate" />}
      </div>
    );
  }
}
/*
  <Tooltip
    title="Edit Group"
    aria-label="Edit Group"
    placement="bottom-left"
  >*/



// WEBPACK FOOTER //
// ./src/pages/Account/Groups/index.js